import logoDefaultUrl from '../assets/logo/bonboca-logo-default.svg';
import logoBlackUrl from '../assets/logo/bonboca-logo-small-black.svg';
import logoSmallUrl from '../assets/logo/bonboca-logo-small-no-subtext.svg';
import logoSmallWithTaglineUrl from '../assets/logo/bonboca-logo-small-with-tagline.svg';

const LOGO_SOURCES = {
  /** Stacked full logo with emblem above text — use for splash/landing contexts */
  default: logoDefaultUrl,
  /** Compact horizontal logo without tagline — use on mobile / small spaces */
  small: logoSmallUrl,
  /** Compact horizontal logo with "Food delivery in Curaçao" tagline — use on desktop header */
  'small-with-tagline': logoSmallWithTaglineUrl,
  /** Compact horizontal logo in black — use on dark sidebar backgrounds with CSS invert */
  black: logoBlackUrl,
} as const;

export type LogoVariant = keyof typeof LOGO_SOURCES;

export interface LogoProps {
  className?: string;
  variant?: LogoVariant;
}

export function Logo({ className, variant = 'small' }: LogoProps) {
  return <img alt="Bon Boca" className={className} src={LOGO_SOURCES[variant]} />;
}
